<template>

    <data-variable-base :variable="variable" :value="value" @delete="emitDelete(variable)">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <v-menu
                v-show="!isMasked"
                v-model="menuModel"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="350px"
                horizontal
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="localizedModel"
                        :label="variable.name.replace('_',' ')"
                        readonly
                        v-on="on"
                        :disabled="isDisabled"
                        :persistent-hint="!!hint"
                        :hint="hint"
                        :hide-details="!hint"
                    ></v-text-field>
                </template>

                <validation-provider
                    name="Date"
                    rules="required"
                    v-slot="{ errors }">

                    <v-date-picker
                        v-model="model"
                        @input="menuModel = false"
                        header-color="primary"
                        landscape
                        color="primary"
                    ></v-date-picker>

                </validation-provider>

            </v-menu>

        </validation-observer>
    </data-variable-base>

</template>

<script>

import {dataVariableInputMixin} from './dataVariableInputMixin';
import MaskedField from './MaskedField';
import {timeDisplay} from '../../../../components/mixins/timeDisplayMixin';
import DataVariableBase from "./DataVariableBase";

export default {

    mixins: [dataVariableInputMixin, timeDisplay],

    components: {
        MaskedField,
        DataVariableBase
    },

    props: {
        value: {
            type: String | null,
            required: true
        },
    },

    watch: {
        value(value) {
            this.model = value;
        },
        model(newValue, oldValue) {
            // Actual validation is done inside mixin!
            // Emit changed values only
            if (oldValue !== newValue && oldValue !== null) this.emit(newValue);
        },
    },

    data() {
        return {
            model: null,
            menuModel: null,
        }
    },

    computed: {

        localizedModel() {
            if (this.model) {
                return this.formatDate(this.model);
            }
        },

        answer: {
            get() {
                return this.value;
            },
            set(value) {
                this.model = value;
            }
        }
    },
}
</script>
